import getUserContextByMetric from "./getUserContextByMetric";
import { QUESTION_TYPE } from "../consts/survey";

const parseResponse = (question) => {
  if (typeof question.current_response === "undefined" || question.current_response === "") {
    return "";
  }
  if (typeof question.current_response === "string") {
    return JSON.parse(question.current_response);
  }
  return question.current_response;
};

const mountCurrentResponse = (question) => {
  const currentRespose = {
    uuid: question.item_uuid,
    type: question.type,
    answer: {
      response: parseResponse(question),
      comment: question.current_comment ? question.current_comment : "",
      context: getUserContextByMetric(question.type, question.current_response, question.min_scale, question.max_scale)
    }
  };
  return currentRespose;
};

const mountSurveyPartialAnswers = (survey) => {
  const answers = [];
  for (let question of survey.items) {
    if (
      (typeof question.current_response !== "undefined" && question.current_response !== "") ||
      question.current_comment
    ) {
      const currentResponse = mountCurrentResponse(question);

      if (question.current_option_other) {
        currentResponse.answer.option_other = question.current_option_other;
      }

      answers.push(currentResponse);
    }
  }
  return answers;
};

const getEmailAnswer = (answer, survey) => {
  let emailAnswer = answer;
  if (typeof emailAnswer === "undefined") {
    return null;
  }
  const pattern = /\D/g;

  const isNotNumber = pattern.test(answer);
  if (!isNotNumber) {
    emailAnswer = Number(answer);
  }

  for (const question of survey.items) {
    if (question.type === QUESTION_TYPE.LABEL || question.type === QUESTION_TYPE.IMAGE) {
      continue;
    }
    if (question.type === QUESTION_TYPE.MULTIPLE_CHOICE) {
      emailAnswer = getMultipleChoiceAnswer(question, emailAnswer);
    }
    const firstQuestion = { ...question, current_response: emailAnswer };

    return mountCurrentResponse(firstQuestion);
  }
};

const updateAnswers = (answers, currentAnswer) => {
  const currentAnswers = [...answers];
  const index = currentAnswers.findIndex((answer) => answer.uuid === currentAnswer.uuid);
  if (index !== -1) {
    currentAnswers[index] = currentAnswer;
  } else {
    currentAnswers.push(currentAnswer);
  }
  return currentAnswers;
};

const getMultipleChoiceAnswer = (item, answer) => {
  for (const option of item.options) {
    for (const key in option) {
      if (option[key] === answer) {
        return option;
      }
    }
  }
  return "";
};

export { mountSurveyPartialAnswers, getEmailAnswer, updateAnswers };
